import { validateNumber } from '@om/validation';
import {
    AMOUNT_BORROWED_SET_VALUE,
    setAmountBorrowedValid,
    CUSTOM_AMOUNT_BORROWED_SET_VALUE,
    setCustomAmountBorrowedValid,
    REPAYMENT_DURATION_SET_VALUE,
    setRepaymentDurationValid,
    CUSTOM_REPAYMENT_DURATION_SET_VALUE,
    setCustomRepaymentDurationValid,
} from '../../../actions/namPersonalLoansCalculator/calculator';

export const namPersonalLoansCalculatorValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case AMOUNT_BORROWED_SET_VALUE:
                return setAmountBorrowedValid(null);
            case CUSTOM_AMOUNT_BORROWED_SET_VALUE:
                error = validateNumber(action.value, {
                    subject: 'loan amount',
                    decimalPoints: 0,
                });

                if (!error) {
                    if (action.value < 3000) {
                        error = 'Please enter a loan amount of N$3 000 or more';
                    } else if (action.value > 300000) {
                        error = 'The amount captured may not exceed N$300 000';
                    }
                } else {
                    error = 'Please enter a loan amount of N$3 000 or more';
                }

                return setCustomAmountBorrowedValid(error);
            case REPAYMENT_DURATION_SET_VALUE:
                return setRepaymentDurationValid(null);
            case CUSTOM_REPAYMENT_DURATION_SET_VALUE:
                error = validateNumber(action.value, { subject: 'repayment term', decimalPoints: 0 });

                if (!error) {
                    if (action.value < 6 || action.value > 60) {
                        error = 'Please enter a repayment term from 6 to 60 months';
                    }
                } else {
                    error = 'Please enter a repayment term from 6 to 60 months';
                }

                return setCustomRepaymentDurationValid(error);
            default:
                return null;
        }
    })();

    store.dispatch(validationAction);
    return next(action);
};
